import React from "react"

const Img = props => <img {...props} />

export { Img, Img as Image }
